export default __webpack_public_path__ + "static/media/election2020general.8215afa4.txt";